import { z } from 'zod'

import {
  caseCreateSchema,
  caseUpdateSchema,
  getCasesSchema,
  type GetCaseByIdNormalized,
  type GetCreatedCase,
  type GetCreatedCaseNormalized,
  type GetFuneralHomeCaseNormalized,
} from '@messenger/types'

import { axios } from '@/api/axios.config'

import { sanitizeCaseDates } from '@/utils/sanitizers/sanitizeCaseDates'
import { sanitizeDashboardDates } from '@/utils/sanitizers/sanitizeDashboardDates'

export const getFuneralHomeCases = async (
  archived: z.infer<typeof getCasesSchema>['archived'],
) => {
  const response = await axios.get<{ cases: GetFuneralHomeCaseNormalized[] }>(
    `/funeralHomeCases?archived=${archived}`,
  )
  if (response?.data?.cases) {
    response.data.cases = sanitizeDashboardDates(
      response.data.cases,
    ) as GetFuneralHomeCaseNormalized[]
  }
  return response
}

export const getCase = async (
  caseId: string,
  isM3: boolean = false,
  orderId: string | null = null,
) => {
  const params = {
    ...(isM3 ? { isM3: true } : {}),
    ...(orderId ? { order_id: orderId } : {}),
  }
  const response = await axios.get<GetCaseByIdNormalized>(`cases/${caseId}`, {
    params,
  })
  response.data = sanitizeCaseDates(response.data) as GetCaseByIdNormalized
  return response
}

export const createCase = async (payload: z.infer<typeof caseCreateSchema>) => {
  const response = await axios.post<GetCreatedCase>(`createCase`, payload)
  response.data = sanitizeCaseDates(response.data) as GetCreatedCase
  return response
}

export const updateCase = async (
  caseId: string,
  payload: z.infer<typeof caseUpdateSchema>,
) => {
  const response = await axios.patch<GetCreatedCaseNormalized>(
    `cases/${caseId}`,
    payload,
  )
  response.data = sanitizeCaseDates(response.data) as GetCreatedCaseNormalized
  return response
}
